// initial state
const state = {
  isWaiting : false,
  message : ''
}

// getters
const getters = {
    getIsWaiting(state){
        return state;
    }
}

// actions
const actions = {

  setIsWaiting : ({commit}, payload) => {
    commit('setIsWaiting', payload);
  }
}

// mutations
const mutations = {

  setIsWaiting(state, payload){
      state.isWaiting = payload.isWaiting
      state.message = payload.message;
  }


}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/global.js